import React from "react";
import { Chip as MuiChip, ChipProps as MuiChipProps } from "@mui/material";

export type ChipStatus = "success" | "warning" | "error" | "info" | "neutral";

const STATUS_COLORS: Record<ChipStatus, { bg: string; text: string }> = {
  success: { bg: "#E3F2EA", text: "#2C7A58" },
  warning: { bg: "#F7EDD9", text: "#8A5C0D" },
  error: { bg: "#F8E9E4", text: "#A83C24" },
  info: { bg: "#E6EDF6", text: "#3F5F8A" },
  neutral: { bg: "#EEF1F6", text: "#5C6779" },
};

export interface ChipProps extends Omit<MuiChipProps, "color"> {
  status?: ChipStatus;
}

const Chip: React.FC<ChipProps> = ({ status = "neutral", sx, ...props }) => {
  const { bg, text } = STATUS_COLORS[status];

  return (
    <MuiChip
      size="small"
      sx={{
        backgroundColor: bg,
        color: text,
        fontWeight: 600,
        fontSize: "0.72rem",
        borderRadius: "999px",
        ...sx,
      }}
      {...props}
    />
  );
};

export default Chip;
